import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Button from "../Button";

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

import sw1 from '../../img/TradingTools/sw/sw1.svg';
import sw2 from '../../img/TradingTools/sw/sw2.svg';
import sw3 from '../../img/TradingTools/sw/sw3.svg';
import sw4 from '../../img/TradingTools/sw/sw4.svg';
import sw5 from '../../img/TradingTools/sw/sw5.svg';

const data = [
  {
    img: sw1,
    title: "trading.3",
    description: "trading.4",
  },
  {
    img: sw2,
    title: "trading.5",
    description: "trading.6",
  },
  {
    img: sw3,
    title: "trading.7",
    description: "trading.8",
  },
  {
    img: sw4,
    title: "trading.9",
    description: "trading.10",
  },
  {
    img: sw5,
    title: "trading.11",
    description: "trading.12",
  },
];

function Main() {

  const { t } = useTranslation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);

  return (
    <div className="relative z-50 pt-[40px] xl:pt-[60px] overflow-hidden">
      <div className="max-w-[1220px] relative xl:mx-auto mx-[20px]">
        <div className="flex flex-col xl:flex-row justify-between">
          {/* Левый блок с текстом */}
          <div className="flex flex-col items-start">
            <p className="xl:max-w-[605px] zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21]">
              {t("trading.1")}
            </p>
            <p className="xl:max-w-[443px] text-[#000000B2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
              {t("trading.2")}
            </p>
            <Button className="mt-[40px] xl:mt-[60px]" />
          </div>

          {/* Правый блок со слайдером */}
          <div className="flex flex-col justify-between">
            <div className="mt-[80px] xl:mt-0 xl:w-[497px] h-[250px] md:h-[302px] bg-[#FFFFFF] border border-[#00000033] relative flex flex-col">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                autoplay={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                pagination={{
                  el: paginationRef.current,
                  clickable: true,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  swiper.params.pagination.el = paginationRef.current;
                }}
                className="w-full h-full"
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1280: {
                        slidesPerView: 1,
                    },
                }}
              >
                {data.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="px-[20px] md:px-[50px] bg-[#F1F1F1] pt-[35px] md:border-l h-full border-[#00000033] xl:border-none">
                        <img src={item.img} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[20px]">{t(item.title)}</h2>
                        <p className="ibm-plex text-[12px] xl:text-[14px] mt-[12px] text-[#000000B2]">{t(item.description)}</p>
                    </div>  
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="flex items-center justify-between mt-auto border-t bg-[#F1F1F1] border-[#00000033] h-[48px]">
                <div ref={paginationRef} className="pl-[20px] md:pl-[50px] pb-[5px] !w-[200px]"></div>
                <div className="flex">
                    <button ref={prevRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                    <button ref={nextRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
